import "./App.css";
import Slideshow from "./components/Slideshow";
import SearchDocState from "./context/searchDocument/SearchDocState";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
// import { UserAuthContext } from "./context/userAuth/UserAuthState";
import UserAuthState from "./context/userAuth/UserAuthState"; // ✅ default import
import LoginPage from "./pages/LoginPage"; // Create this component
import ProtectedRoute, { PublicRoute } from "./components/ProtectedRoute"; // We'll define this below
import DashboardPage from "./pages/DashboradPage";
import SettingsPage from "./pages/SettingsPage";
import CertificationsPage from "./pages/CertificationsPage";
import CreateCertificatePage from "./pages/CreateCertificatePage";
import CertificatePreviewPage from "./pages/CertificatePreviewPage";
import CertificateConfigurationPage from "./pages/CertificateConfigurationPage";
import InvoicesPage from "./pages/InvoicesPage";
import CreateInvoicePage from "./pages/CreateInvoicePage";


function SearchPage() {
  return (
    <SearchDocState>
      <div className="App">
        <Slideshow />
      </div>
    </SearchDocState>
  );
}

function App() {
  return (
    <UserAuthState>
      <Router>
        <Routes>
          {/* Default route redirects to dashboard */}
          <Route path="/" element={<SearchPage />} />
          <Route path="/certificate-preview" element={<CertificatePreviewPage />} />
          {/* Login page — redirects to dashboard if already logged in */}
          <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />

          {/* Protected dashboard route */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route path="/all-certifications" element={
            <ProtectedRoute>
              <CertificationsPage />
            </ProtectedRoute>
          } />
          <Route path="/create-certificate" element={
            <ProtectedRoute>
              <CreateCertificatePage />
            </ProtectedRoute>
          } />
          <Route path="/all-invoices" element={
            <ProtectedRoute>
              <InvoicesPage />
            </ProtectedRoute>
          } />
          <Route path="/create-invoice" element={
            <ProtectedRoute>
              <CreateInvoicePage />
            </ProtectedRoute>
          } />
          <Route path="/certificate-configuration" element={
            <ProtectedRoute>
              <CertificateConfigurationPage />
            </ProtectedRoute>
          } />
          <Route path="/settings" element={
            
            <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>} />
        </Routes>
      </Router>
    </UserAuthState>
  );
}

export default App;
